import helpers from './lib/helpers';
import Errors from './forms/Errors';
import Query from './lib/Query';
import PortalVue from 'portal-vue';
import BaseModel from './models/BaseModel';
import Tree from './components/Tree';
import Toggle from '../components/toggle/toggle';
import Spinner from './components/Spinner';
import Image from './components/image.js';
import FormFields from './components/FormFields';
import Select from './components/Select';
import Datepicker from './components/Datepicker';
import Timepicker from './components/Timepicker';
import Gallery from './components/Gallery';
import FormErrors from './components/FormErrors';
import Alert from './components/Alert';
import Tag from './components/Tag';
import FormField from './components/FormField';
import Form from './forms/Form';
import TForm from './components/Form';
import Table from './components/Table';
import Grid from './components/Grid';
import PerPage from './components/PerPage';
import Pagination from './components/Pagination';
import DropdownTree from './components/DropdownTree';
import TableData from './components/TableData';
import TextArea from './components/TextArea';
import Avatar from './components/Avatar';
import MonthPicker from './components/MonthPicker';
import DayPicker from './components/DayPicker';
import Repeater from './components/Repeater';
import Cleave from './components/cleave.js';
import Slider from './components/Slider';
import Number from './components/Number';
import Chart from './components/Chart';
import Popper from './components/Popper';
import Carousel from './components/Carousel';
import Setting from './components/Setting';
import File from './components/File';
import FilePreview from './components/FilePreview';
import Confirm from './directives/confirm/confirm';
import Loading from './directives/loading/loading';
import Collapse from './directives/collapse/collapse';
import DataDir from './directives/data/data';
import PopperDirective from './directives/popper/popper';
import Renderless from './components/renderless';
import Text from './components/Text';
import Icon from './components/icon';
import Modal from './components/Modal';
import AjaxForm from './components/AjaxForm';
import FormSelect from './components/FormSelect';
import LivewireFileProgress from './components/LivewireFileProgress';

Vue.use(PortalVue);

const JGile = {
    install(Vue, options) {
        Vue.component('file-progress-component', LivewireFileProgress);
        Vue.component('t-ajax-form', AjaxForm);
        Vue.component('t-modal', Modal);
        Vue.component('t-icon', Icon);
        Vue.component('t-form', TForm);
        Vue.component('t-setting', Setting);
        Vue.component('t-file', File);
        Vue.component('t-file-preview', FilePreview);
        Vue.component('t-chart', Chart);
        Vue.component('popper', Popper);
        Vue.component('t-carousel', Carousel);
        Vue.component('t-slider', Slider);
        Vue.component('t-cleave', Cleave);
        Vue.component('t-repeater', Repeater);
        Vue.component('t-pagination', Pagination);
        Vue.component('t-per-page', PerPage);
        Vue.component('t-grid', Grid);
        Vue.component('t-number', Number);
        Vue.component('t-day-picker', DayPicker);
        Vue.component('t-month-picker', MonthPicker);
        Vue.component('t-avatar', Avatar);
        Vue.component('t-textarea', TextArea);
        Vue.component('t-table', Table);
        Vue.component('t-table-data', TableData);
        Vue.component('t-tag', Tag);
        Vue.component('t-alert', Alert);
        Vue.component('t-dropdown-tree', DropdownTree);
        Vue.component('t-form-select', FormSelect);
        Vue.component('t-select', Select);
        Vue.component('t-gallery', Gallery);
        Vue.component('t-tree', Tree);
        Vue.component('t-toggle', Toggle);
        Vue.component('t-spinner', Spinner);
        Vue.component('t-datepicker', Datepicker);
        Vue.component('t-timepicker', Timepicker);
        Vue.component('form-errors', FormErrors);
        Vue.component('t-img', Image);
        Vue.component('t-form-fields', FormFields);
        Vue.component('t-form-field', FormField);
        Vue.component('t-text', Text);
        Vue.component('renderless', Renderless);
        Vue.directive('confirm', Confirm);
        Vue.directive('loading', Loading);
        Vue.directive('collapse', Collapse);
        Vue.directive('popper', PopperDirective);
        Vue.directive('data', DataDir);

        _.each(helpers, (val, key) => {
            if (!window[key]) {
                window[key] = val;
            }
        });
    },
};

export {
    TForm,
    Setting,
    File,
    FilePreview,
    Chart,
    Repeater,
    Pagination,
    BaseModel,
    Cleave,
    Popper,
    Grid,
    Carousel,
    Avatar,
    TextArea,
    Tree,
    Toggle,
    Spinner,
    Loading,
    Image,
    Number,
    FormFields,
    Tag,
    Alert,
    Modal,
    Slider,
    FormErrors,
    FormSelect,
    AjaxForm,
    Gallery,
    Timepicker,
    Datepicker,
    Select,
    FormField,
    Text,
    TableData,
    PerPage,
    Collapse,
    Form,
    Errors,
    Query,
    JGile,
};

export default JGile;
